interface PromptTranslationPrefs {
  enabled: boolean
}

class PreferencesService {
  private readonly keyEnabled = 'prompt_translation_enabled'

  getPromptTranslation(): PromptTranslationPrefs {
    const enabled = localStorage.getItem(this.keyEnabled)
    // Eğer localStorage'da değer yoksa, varsayılan olarak true döndür
    if (enabled === null) {
      return {
        enabled: true,
      }
    }
    return {
      enabled: enabled === 'true',
    }
  }

  setPromptTranslationEnabled(enabled: boolean) {
    localStorage.setItem(this.keyEnabled, enabled ? 'true' : 'false')
  }
}

export const preferencesService = new PreferencesService()
export default preferencesService


